import { render, staticRenderFns } from "./cash.vue?vue&type=template&id=58984de5&"
import script from "./cash.vue?vue&type=script&lang=ts&"
export * from "./cash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports